import { all_routes } from "../../../feature-module/router/all_routes";
const routes = all_routes;

export const SidebarDataTest = [
  {
    tittle: '',
    icon: 'airplay',
    showAsTab: true,
    separateRoute: false,
    submenuItems: [
      {
        label: 'Platform Dashboard',
        link: routes.adminDashboard,
        submenu: false,
        showSubRoute: false,
        icon: 'smart-home',
        base: 'owner-dashboard',
        key: 'owner-dashboard'
      },
      {
        label: 'Dashboard',
        link: routes.adminDashboard,
        submenu: false,
        showSubRoute: false,
        icon: 'smart-home',
        base: 'dashboard',
        key:'dashboard'
      },
      {
        label: 'Users',
        link: routes.employeeGrid,
        submenu: false,
        showSubRoute: false,
        icon: 'users',
        base: 'employees',
        materialicons: 'people',
        key:'users'
      },
      {
        label: 'All Tasks',
        link: routes.tickets,
        // base: 'ticket-list',
        icon: 'slice',
        key:'tickets'
      },
      {
        label: 'Kanban Board',
        link: routes.kanbanView,
        // base: 'ticket-list',
        icon: 'clipboard',
        key:'kanban'
      },
      {
        label: 'Reset Password',
        submenu: false,
        link: routes.resetPassword2,
        showSubRoute: false,
        icon: 'restore',
        key:'reset-password'
      },
      {
        label: 'Organisations',
        link: '/owner/organisations',
        submenu: false,
        showSubRoute: false,
        icon: 'building',
        key:'organisations'
      },
      {
        label: 'Masters',
        link: '/org-masters',
        submenu: false,
        showSubRoute: false,
        icon: 'settings',
        key:'org-masters'
      },
      {
        label: 'Users',
        link: '/org-users',
        submenu: false,
        showSubRoute: false,
        icon: 'user-plus',
        key:'org-users'
      },
      {
        label: 'Roles',
        link: '/org-roles',
        submenu: false,
        showSubRoute: false,
        icon: 'shield',
        key:'org-roles'
      },
      {
        label: 'External WhatsApp',
        link: '/org-external-updates',
        submenu: false,
        showSubRoute: false,
        icon: 'brand-whatsapp',
        key: 'org-external-updates'
      },
    ],
  }, 
];